/**
 * Product Details Variant Handler
 *
 * Handles showing/hiding variant-specific content in product details:
 * - Product descriptions
 * - Specification tables
 * - Manual book links
 * - Highlighted content
 * - PDP v2 specs_v2 rows
 *
 * Listens for 'on:variant:change' events from variant-picker component
 */

(function () {
  "use strict";

  if (window.__productDetailsVariantHandlerInitialized) {
    return;
  }
  window.__productDetailsVariantHandlerInitialized = true;

  class ProductDetailsVariantHandler {
    constructor() {
      this.currentVariantId = null;
      this.init();
    }

    init() {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.setupListeners());
      } else {
        this.setupListeners();
      }
    }

    setupListeners() {
      document.addEventListener("on:variant:change", (event) => {
        this.handleVariantChange(event);
      });

      this.setInitialState();
    }

    handleVariantChange(event) {
      const variant = event.detail?.variant;

      if (!variant || !variant.id) {
        this.updateVariantElements(null);
        return;
      }

      this.currentVariantId = variant.id.toString();
      this.updateVariantElements(this.currentVariantId);
    }

    updateVariantElements(variantId) {
      document.querySelectorAll(".product-description [data-variant-id]").forEach((element) => {
        const elementVariantId = element.getAttribute("data-variant-id");
        const isMatch = variantId && elementVariantId === variantId;
        const descriptionParent = element.closest(".product-description");

        if (isMatch) {
          element.classList.remove("hidden");
          element.classList.add("active");
          if (descriptionParent) {
            descriptionParent.classList.add("has-active-variant");
          }
        } else {
          element.classList.add("hidden");
          element.classList.remove("active");
          if (descriptionParent) {
            descriptionParent.classList.remove("has-active-variant");
          }
        }
      });

      document.querySelectorAll(".product-details [data-variant-id]").forEach((element) => {
        if (element.classList.contains("spec-kv-variant-specs")) return;
        if (element.closest(".product-description")) return;

        const elementVariantId = element.getAttribute("data-variant-id");
        const isMatch = variantId && elementVariantId === variantId;

        element.classList.toggle("hidden", !isMatch);
        element.classList.toggle("active", !!isMatch);
      });

      this.updateSpecTableRows(variantId);
      this.updateSpecKvVariantSpecs(variantId);
      this.updatePackageContents(variantId);
      document.dispatchEvent(new CustomEvent("on:spec-variant:change", { detail: { variantId } }));
    }

    updatePackageContents(variantId) {
      document.querySelectorAll(".product-package-contents [data-hose-length]").forEach((element) => {
        const elementVariantId = element.getAttribute("data-variant-id");
        const isMatch = variantId && elementVariantId === variantId;

        element.classList.toggle("hidden", !isMatch);
      });

      document.querySelectorAll(".product-package-contents__card[data-visible-variant-ids]").forEach((card) => {
        const visibleVariantIds = card
          .getAttribute("data-visible-variant-ids")
          .split(",")
          .filter(Boolean);
        const isMatch = variantId && visibleVariantIds.includes(variantId);

        card.classList.toggle("hidden", !isMatch);
      });
    }

    updateSpecTableRows(variantId) {
      const specTable = document.querySelector(".spec-table");
      if (!specTable) return;

      const rows = specTable.querySelectorAll("tbody tr[data-table-variant-id]");

      rows.forEach((row) => {
        const rowVariantId = row.getAttribute("data-table-variant-id");
        const isMatch = variantId && rowVariantId === variantId;

        if (isMatch) {
          row.classList.add("spec-table-row--active");
          row.classList.remove("spec-table-row--inactive");
        } else {
          row.classList.remove("spec-table-row--active");
          row.classList.add("spec-table-row--inactive");
        }
      });
    }

    updateSpecKvVariantSpecs(variantId) {
      const panels = document.querySelectorAll(".spec-kv-variant-specs[data-variant-id]");

      panels.forEach((panel) => {
        const panelVariantId = panel.getAttribute("data-variant-id");
        const isMatch = variantId && panelVariantId === variantId;

        panel.classList.toggle("hidden", !isMatch);
        panel.classList.toggle("active", !!isMatch);
      });
    }

    setInitialState() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get("variant");

      if (urlVariantId) {
        this.currentVariantId = urlVariantId;
        this.updateVariantElements(this.currentVariantId);
        return;
      }

      const variantInput = document.querySelector('.js-product-form-main input[name="id"]');
      if (variantInput?.value) {
        this.currentVariantId = variantInput.value;
        this.updateVariantElements(this.currentVariantId);
      }
    }
  }

  new ProductDetailsVariantHandler();
})();
